/**
 * Checks whether should move to the previous page based on the provided pagination data and
 * moved content.
 *
 * @param {number} count - The total number of items across all pages.
 * @param {number} limit - The number of items per page.
 * @param {number} page - The current page number.
 * @param {number} offset - The number of items to skip from the beginning of the list
 * @param {number} numMovedContent - The quantity of moved items.
 *
 * @returns {boolean} - Returns `false` if has only one page, it's not the last page or
 * if moved items are less than the page limit.
 */

interface PaginationData {
  count: number;
  limit: number;
  page: number;
  offset: number;
  numMovedContent: number;
}

export function shouldMoveToPreviousPage({
  count,
  limit,
  page,
  numMovedContent,
  offset,
}: PaginationData): boolean {
  // if has only one page
  if (count <= limit) {
    return false;
  }

  const totalPages = Math.ceil(count / limit);
  const itemsInPage = count - offset;
  return page === totalPages && numMovedContent === itemsInPage;
}
